<template>
    <div ref="container" 
        class="demo-monitor relative my-6">
        <TwicImg :src="monitorImageSrc" class="w-full opac relative z-10 " ratio="100/85" intrinsic="2000x1698"
            mode="contain" placeholder="none" />
        <div class="monitor-video absolute">
            <video
                ref="monitorVideo"
                class="h-full w-full object-cover"
                autoplay loop muted="true" playsinline
               >
                <source :src="'https://workbook.7mesh.com/videos/clouds_lo.mp4'" type="video/mp4" />
            </video>
        </div>
        <div class="splittexts absolute flex flex-col justify-center items-center overflow-hidden">
            
            <p class="animtext splittext1 text-base md:text-4xl lg:text-2xl xl:text-4xl mb-1 md:mb-8">
                {{ props.text1 }}

            </p>
            <p class="animtext splittext2 text-base md:text-4xl lg:text-2xl xl:text-4xl  mb-0">
                {{ props.text2 }}

            </p>
        </div>
    </div>
</template>

<script setup lang="ts">

import { computed, nextTick, onMounted, onUnmounted, ref } from 'vue'
import { useRuntimeConfig } from '#app'
import { loadGsap } from '@/utils/gsap'

const container = ref<HTMLElement | null>(null)
const monitorVideo = ref<HTMLVideoElement | null>(null)
const isMounted = ref(false)
const splitReady = ref(false)
const config = useRuntimeConfig()
const monitorImageSrc = computed(() =>
    '/images/intro/monitor-home.png' + '?deployment=' + config.public.appVersion
)

let ctx: gsap.Context | null = null

const props = defineProps({
    text1: {
        type: String,
        default: ''
    },
    text2: {
        type: String,
        default: ''
    }
})

onMounted(async () => {
   

    const { gsap, SplitText, ScrollTrigger } = await loadGsap()
    const p = container.value?.querySelectorAll('p')
    ctx = gsap.context(() => {

        const split1 = SplitText.create('.splittext1', { type: 'words, chars', aria: false })
        const split2 = SplitText.create('.splittext2', { type: 'words, chars', aria: false })
        splitReady.value = true

        gsap.from(split1.words, {
            delay: 1,
            duration: 0.2,
            x: 50,
            autoAlpha: 0,
            stagger: 0.1,
        })

        gsap.from(split2.words, {
            delay: 2.5,
            duration: 0.5,
            x: 30,
            autoAlpha: 0,
            stagger: 0.1,
        })
        // Fade out texts on scroll
        if (p?.length) {
            const tl = gsap.timeline({
                scrollTrigger: {
                    trigger: container.value,
                    markers: false,
                    start: 'bottom 65%',
                    end: 'bottom 20%',
                    scrub: true
                }
            })
            tl.to(p, { y: 100, duration: 10, opacity: 0, stagger: -1.5 })
            ScrollTrigger.refresh()
        }
    }, container.value)
})

onUnmounted(() => {
    ctx?.revert()
    ctx = null
})
</script>
